import Vue from 'vue';
import DialogComponent from './CaptchaDialog.vue';

let instance;

const defaultOptions = {
  value: true,
  overlay: true,
  lockOnScroll: true,
  closeOnClickOverlay: true,
  // submitAction: function (value) {
  //   console.log("CaptchaDialog submitAction", value);
  // },
  captcha:'',
  callback: (action,value) => {
    instance[action === 'confirm' ? 'resolve' : 'reject'](value);
  }
};

let currentDefaultOptions = {
  ...defaultOptions
};

const initInstance = () => {
  const DialogConstructor = Vue.extend(DialogComponent);
  instance = new DialogConstructor({
    el: document.createElement('div')
  });

  instance.$on('input', value => {
    instance.value = value;
  });

  document.body.appendChild(instance.$el);
};

const Dialog = options => {
  return new Promise((resolve, reject) => {
    if (!instance) {
      initInstance();
    }

    Object.assign(instance, {
      resolve,
      reject,
      ...options
    });
  });
};

Dialog.show = options => Dialog({
  ...currentDefaultOptions,
  ...options
});


Dialog.close = () => {
  instance.value = false;
};

Dialog.setDefaultOptions = (options = {}) => {
  currentDefaultOptions = {
    ...currentDefaultOptions,
    ...options
  };
};

Dialog.resetDefaultOptions = () => {
  currentDefaultOptions = {
    ...defaultOptions
  };
};

Vue.prototype.$captcha_dialog = Dialog;
window.$captcha_dialog = Dialog;

export default Dialog;
export {
  DialogComponent as Dialog
};



// WEBPACK FOOTER //
// ./src/components/Popups/CaptchaDialog/index.js